import { createApplicationFormSelector } from './createApplicationFormSelector';

export const selectPassport = (state) => ({
  series: createApplicationFormSelector(state, 'passport_series'),
  number: createApplicationFormSelector(state, 'passport_number'),
  date: createApplicationFormSelector(state, 'passport_issue_date'),
  issuerCode: createApplicationFormSelector(state, 'passport_issuer_code'),
  issuerName: createApplicationFormSelector(state, 'passport_issuer_name'),
});
